/*
 * 佳安卫康内部流程
 */
import * as Names from '../statuses'
export default {
  name: 'TASK',
  statuses: [{
    name: Names.LAB_SAMPLE_RETURNED,
    description: '样本重采',
    operation: '样本重采',
    icon: ''
  },
  {
    name: Names.CREATE,
    description: '创建任务单',
    operation: '创建任务单',
    completeText: '创建任务单',
    icon: 'icon-chuangjian'
  },
  {
    name: 'ORDER_GET',
    description: '待领样',
    operation: '待领样',
    completeText: '已领样',
    icon: 'icon-yangpindailingyang',
    type: 'lab'
  },
  {
    name: 'ORDER_EXAM',
    description: '检测中',
    operation: '检测中',
    completeText: '已检测',
    icon: 'icon-yangpinjiancezhong',
    type: 'lab'
  },
  {
    name: 'REPORT_CREATE',
    description: '待报告',
    operation: '待报告',
    completeText: '已报告',
    icon: 'icon-yangpindaibaogao',
    type: 'lab'
  },
  {
    name: 'REPORT_CHECKED',
    description: '待审核',
    operation: '待审核',
    completeText: '已审核',
    type: 'report',
    icon: 'icon-yangpindaishenhe'
  },
  {
    name: 'ORDER_BACK',
    description: '待归还',
    operation: '待归还',
    completeText: '已归还',
    type: 'report',
    icon: 'icon-yangpindaiguihuan'
  },
  {
    name: Names.COMPLETED,
    description: '已完成',
    operation: '已完成',
    completeText: '已完成',
    icon: 'icon-yiwancheng'
  },
  {
    name: Names.CLOSED,
    description: '已关闭',
    operation: '已关闭',
    icon: 'icon-dingdanguanbi'
  }
  ]
}
